import api from '@pray/shared/utils/api';

import type { CreateReportResponse } from './data/response';
import type { CreateReportRequest } from './data/types';

type CreateReportProps = {
  artistId: string;
  data: CreateReportRequest;
};

export async function createReport({ artistId, data }: CreateReportProps): Promise<CreateReportResponse> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/reports`;

  const response = await api.executePostRequest<CreateReportResponse>(url, data);
  return response.data;
}
